import { DbTimestampGenerated, DbTimestampNullable } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';
import { expectTypeOf } from 'expect-type';
import {
  ColumnType,
  GeneratedAlways,
  Insertable,
  Selectable,
  Updateable,
} from 'kysely';
import { z } from '@harvestiq/zod';

export type EvergreenSigningAgentsTable = {
  id: GeneratedAlways<string>;
  aipInsuranceAgentKey: ColumnType<string | null>;
  agentSsnEncrypted: ColumnType<string | null>;
  lastName: ColumnType<string | null>;
  firstName: ColumnType<string | null>;
  middleName: ColumnType<string | null>;
  suffix: ColumnType<string | null>;
  title: ColumnType<string | null>;
  email: ColumnType<string | null>;
  phone: ColumnType<string | null>;
  raceQuestionTypeCode: ColumnType<string | null>;
  ethnicityQuestionTypeCode: ColumnType<string | null>;
  genderQuestionTypeCode: ColumnType<string | null>;
  createdBy: ColumnType<string | null>;
  updatedBy: ColumnType<string | null>;
  importSourceId: ColumnType<string | null>;
  mergedIntoEvergreenSigningAgentId: ColumnType<string | null>;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
  deletedAt: DbTimestampNullable;
};

export type DbEvergreenSigningAgent = Selectable<EvergreenSigningAgentsTable>;
export type DbEvergreenSigningAgentInsert =
  Insertable<EvergreenSigningAgentsTable>;
export type DbEvergreenSigningAgentUpdate =
  Updateable<EvergreenSigningAgentsTable>;

// zod schema
export const dbEvergreenSigningAgentSchema = z.object({
  id: z.string().uuid(),
  aipInsuranceAgentKey: z.string().nullable(),
  agentSsnEncrypted: z.string().nullable(),
  lastName: z.string().nullable(),
  firstName: z.string().nullable(),
  middleName: z.string().nullable(),
  suffix: z.string().nullable(),
  title: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  raceQuestionTypeCode: z.string().nullable(),
  ethnicityQuestionTypeCode: z.string().nullable(),
  genderQuestionTypeCode: z.string().nullable(),
  createdBy: z.string().nullable(),
  updatedBy: z.string().nullable(),
  importSourceId: z.string().uuid().nullable(),
  mergedIntoEvergreenSigningAgentId: z.string().uuid().nullable(),
  createdAt: zTimestamp(),
  updatedAt: zTimestamp(),
  deletedAt: zTimestamp().nullable(),
});

export const dbEvergreenSigningAgentInsertSchema = dbEvergreenSigningAgentSchema
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    mergedIntoEvergreenSigningAgentId: true,
    deletedAt: true,
  })
  .partial();

export const dbEvergreenSigningAgentUpdateSchema = dbEvergreenSigningAgentSchema
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  })
  .partial();

expectTypeOf<DbEvergreenSigningAgent>().toMatchTypeOf<
  z.infer<typeof dbEvergreenSigningAgentSchema>
>();
expectTypeOf<DbEvergreenSigningAgentInsert>().toMatchTypeOf<
  z.infer<typeof dbEvergreenSigningAgentInsertSchema>
>();
expectTypeOf<DbEvergreenSigningAgentUpdate>().toMatchTypeOf<
  z.infer<typeof dbEvergreenSigningAgentUpdateSchema>
>();
